import React from 'react';
import c from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import ArrowRightIconNew from '../../../Icons/ArtStageArrowR';
import { CommonArrowButtonProps } from '../../types';
import commonStyles from '../../Slider.scss';

interface Props extends CommonArrowButtonProps {
  arrowSize?: IconSize;
  iconClassName?: string;
}

const DefaultNextButton: React.FC<Props> = ({
  onClick,
  className,
  arrowSize,
  iconClassName,
}) => {
  return (
    <button
      className={c(commonStyles['next-btn'], className)}
      onClick={onClick}
      /**
       * We can hide these from screen readers because they have
       * access to all of the slider content without these buttons
       */
      aria-hidden={true}
      /**
       * Still adding an aria-label to avoid getting pinged by automated a11y tools
       */
      aria-label={'Next'}
    >
      <ArrowRightIconNew
        withPadding={false}
        className={c(commonStyles['arrow-icon'], iconClassName)}
        size={arrowSize}
      />
    </button>
  );
};

DefaultNextButton.displayName = 'DefaultNextButton';

export default DefaultNextButton;
